import { Component, OnInit, Input } from "@angular/core";

import { BaseComponent, UserService, ProductService, environment } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { filter, takeUntil, take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { UpdatePaymentSourceComponent, SubscribeComponent } from "../modals";

@Component({
  selector: "myp-sphere-redeem",
  templateUrl: "sphere-redeem.component.html",
})
export class SphereRedeemComponent extends BaseComponent implements OnInit {
  public shouldShow: boolean;
  public redeeming: boolean = false;
  public shouldShowS15Redeem: boolean = true;
  @Input() stringId: string;
  @Input() product: any;
  @Input() group: any;

  constructor(userService: UserService, public productService: ProductService, public appService: AppService, private _translate: TranslateService) {
    super(userService);
  }

  ngOnInit() {
    this.productService.products$
      .pipe(
        filter((products) => !!products),
        takeUntil(this.destroy$)
      )
      .subscribe((result) => {
        if (result) {
          if (this.stringId == "studioapp4.artist" || this.stringId == "studioapp4.pro") {
            if (!this.userService.user.active_subscription && this.productService.sphereElligibleUpgradeProducts && this.productService.sphereElligibleUpgradeProducts.length) {
              this.group.forEach((prod) => {
                if (this.productService.sphereElligibleUpgradeProducts.filter((item) => item.id == prod.id)[0]) {
                  this.shouldShow = true;
                  return;
                }
              });
            }
          }
        }
      });
  }

  redeem() {
    // if (!this.userService.user.plimus_id || !this.userService.shopperData || !this.userService.shopperData.saved_cards || !this.userService.shopperData.saved_cards.length) {
    //   const modalRef = this.appService.showModal(UpdatePaymentSourceComponent, {size: 'lg'});
    //   modalRef.componentInstance.subscribing = true;
    //   modalRef.componentInstance.redeemingGracePeriodUpgrade = true;
    //   modalRef.componentInstance.cardAdded.pipe(take(1)).subscribe(result => {
    //     this.userService.getUserDetails({autoSubscribe: false}).subscribe(result => {
    //       const modalRef = this.appService.showModal(SubscribeComponent, {size: 'lg'});
    //     })
    //   })
    // } else {
    //   const modalRef = this.appService.showModal(SubscribeComponent, {size: 'lg'});
    // }
    const modalRef = this.appService.showModal(SubscribeComponent, { size: "lg" });
    modalRef.componentInstance.groupId = this.product.id;
  }
}
